'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Carousel } from '@components/carousel';

export const Slider = ({ slides }: { slides: AppImageData[] }) => {
  return (
    <Carousel
      loop
      variant="main"
      spaceBetweenSlides={20}
      navigation={true}
      pagination={{ clickable: true }}
      customClassNames={{
        leftButton: 'max-lg:hidden ',
        rightButton: 'max-lg:hidden',
        main: 'max-sm:!rounded-none',
      }}
      buttonsPosition="bottom"
      customPagination={{
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletClass:
          'w-3 h-3 rounded-full bg-custom-surface-contrast-low max-sm:!mr-0 cursor-pointer',
        bulletActiveClass: 'bg-status-accent',
      }}
    >
      {slides.map((img, index) => (
        <Carousel.Item
          key={index}
          className="flex h-full w-full items-center justify-center"
          style={{ width: '100%' }}
        >
          <div
            className={'flex w-full items-center justify-center max-lg:w-full'}
          >
            <AppImageClient {...img} alt="map" className="h-auto w-full" />
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
